export const exchangeErrorToText = {
  'classes-overlap': 'Ao realizar esta troca, haveriam conflitos para alguma pessoa envolvida na troca.',
  'students-with-incorrect-classes': 'Alguma das pessoas envolvidas não está numa das turmas incluídas na troca.',
  'duplicate-request': 'Já existe um pedido de troca igual a este.',
}
